import classNames from "classnames";
import { FC, ReactNode } from "react";

import { FormError } from "..";

interface IProps {
  id: string;
  name: string;
  title: string | React.ReactNode;
  titleClasses?: string;
  subTitle?: string | React.ReactNode;
  subTitleClasses?: string;
  hint?: React.ReactNode;
  classes?: string;
  theme?: "light" | "dark";
  column?: "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "11" | "12";
  type?: "radio" | "card" | "card-brief" | "card-list";
  register: any;
  onChange?: (val: string) => void;
  onBlur?: React.ChangeEventHandler<HTMLInputElement>;
  error?: string;

  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;

  watch: any;
  setValue: any;
  icon?: any;
}

export const IncDec: FC<IProps> = ({
  id,
  type,
  register,
  name,
  onChange,
  onBlur,
  title,
  subTitle,
  error,
  disabled = true,
  readOnly = false,
  watch,
  setValue,
  ...rest
}) => {
  const onInc = () => {
    setValue(name, watch(name) + 1, { shouldValidate: true });
  };

  const onDec = () => {
    if (watch(name) >= 1) setValue(name, watch(name) - 1, { shouldValidate: true });
  };

  return (
    <article className="w-full flex items-center space-x-5 bg-[#f2f2f2] p-3 rounded-[10px]">
      <div className="flex flex-col w-8 p-2 bg-[#DEDEDE] rounded-[10px]">
        <button type="button" onClick={onInc}>
          &#43;
        </button>
        <input
          {...register(name, { onChange, onBlur })}
          id={id}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          className="bg-transparent focus:outline-none text-center font-bold"
        />

        <button
          type="button"
          onClick={onDec}
          className={classNames({
            "text-black/20 cursor-not-allowed": watch(name) === 0
          })}
        >
          &#8722;
        </button>
      </div>
      <div className="w-9/12 md:w-5/6">
        {rest.icon ? <rest.icon classes="mb-2" /> : null}
        <p className="text-base font-bold mb-2">{title}</p>
        {subTitle ? <p className="text-sm text-gray-600 font-light mb-2">{subTitle}</p> : null}

        <FormError error={error} id={id} />
      </div>
    </article>
  );
};
